// Email regex components - optimized to avoid backtracking
export const EMAIL_LOCAL_PART_REGEX = /^[a-zA-Z0-9!#$%&'*+\-/=?^_`{|}~]+(?:\.[a-zA-Z0-9!#$%&'*+\-/=?^_`{|}~]+)*$/;
export const EMAIL_DOMAIN_PART_REGEX = /^(?:[a-zA-Z0-9](?:[a-zA-Z\-0-9]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
// Combined email regex
export const VALID_EMAIL = new RegExp(`^${EMAIL_LOCAL_PART_REGEX.source.slice(1, -1)}@${EMAIL_DOMAIN_PART_REGEX.source.slice(1, -1)}$`);
// Email validation constants
export const MAX_EMAIL_LENGTH = 200;
// Define NON_PROD_WEBEX_URL if not imported from elsewhere
export const NON_PROD_WEBEX_URL = {
    U2C: "https://u2c-intb.ciscospark.com/u2c/api/v1",
    HYDRA: "https://hydra-intb.ciscospark.com/v1"
};
export const EXTERNAL_LINKS = {
    TERMS_OF_SERVICE: "https://www.cisco.com/c/en/us/about/legal/cloud-and-software/cloud-terms.html",
    PRIVACY_STATEMENT: "https://www.cisco.com/c/en/us/about/legal/privacy.html",
    ABOUT_WEBEX: "https://www.webex.com/",
    NEED_HELP_SIGNING_IN: "https://help.webex.com/en-us/n5q6x5j/Sign-In-Issues-with-Webex"
};
export const LOGIN_LOGS = {
    REDIRECT: "Login/Webex/Redirect",
    INITIALIZATION: "Login/Webex/Initialize"
};
export const UUIP_TOKEN_KEY = "uuip-auth-token";
export const WEBEX_TOKEN_KEY = "webex-token";
export const WEBEX_READY_TIMEOUT_MS = 30000;
export const TOKEN_REFRESH_TIMEOUT = 60000; // 60 seconds
